module.exports = __webpack_public_path__ + "static/cat-d5f1c8da27c7e20171e6be0b93b2bc4e.svg";